import React from 'react';
import { Clock } from 'lucide-react';

const OpeningHours = ({ language }) => {
  const content = {
    de: {
      title: "Öffnungszeiten",
      subtitle: "Besuchen Sie uns zu diesen Zeiten",
      days: [
        { day: "Montag", hours: "09:00 – 19:00" },
        { day: "Dienstag", hours: "09:00 – 19:00" },
        { day: "Mittwoch", hours: "09:00 – 19:00" },
        { day: "Donnerstag", hours: "09:00 – 19:00" },
        { day: "Freitag", hours: "09:00 – 19:00" },
        { day: "Samstag", hours: "09:00 – 19:00" },
        { day: "Sonntag", hours: "Geschlossen" }
      ]
    },
    en: {
      title: "Opening Hours",
      subtitle: "Visit us during these hours",
      days: [
        { day: "Monday", hours: "09:00 – 19:00" },
        { day: "Tuesday", hours: "09:00 – 19:00" },
        { day: "Wednesday", hours: "09:00 – 19:00" },
        { day: "Thursday", hours: "09:00 – 19:00" },
        { day: "Friday", hours: "09:00 – 19:00" },
        { day: "Saturday", hours: "09:00 – 19:00" },
        { day: "Sunday", hours: "Closed" }
      ]
    }
  };

  const getCurrentStatus = () => {
    const now = new Date();
    const currentDay = now?.getDay(); // 0 = Sunday, 1 = Monday, etc.
    const currentHour = now?.getHours();
    
    // Check if it's Sunday (closed)
    if (currentDay === 0) {
      return {
        isOpen: false,
        status: language === 'de' ? 'Geschlossen' : 'Closed'
      };
    }
    
    // Check if within opening hours (9-19)
    if (currentHour >= 9 && currentHour < 19) {
      return {
        isOpen: true,
        status: language === 'de' ? 'Geöffnet' : 'Open'
      };
    } else {
      return {
        isOpen: false,
        status: language === 'de' ? 'Geschlossen' : 'Closed'
      };
    }
  };

  const status = getCurrentStatus();

  return (
    <section id="hours" className="py-16 lg:py-24 bg-primary">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-secondary mb-4">
            {content?.[language]?.title}
          </h2>
          <p className="font-body text-lg text-white/80 mb-8">
            {content?.[language]?.subtitle}
          </p>
          
          {/* Current Status */}
          <div className={`inline-flex items-center space-x-2 px-4 py-2 rounded-full ${
            status?.isOpen ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
          }`}>
            <Clock size={16} />
            <span className="font-body font-medium text-sm">
              {status?.status}
            </span>
          </div>
        </div>

        {/* Hours Grid */}
        <div className="bg-secondary/10 rounded-xl p-6">
          <div className="grid gap-3">
            {content?.[language]?.days?.map((schedule, index) => {
              const today = new Date()?.getDay();
              const dayIndex = today === 0 ? 6 : today - 1; // Convert Sunday=0 to our array index
              const isToday = index === dayIndex;
              const isClosed = schedule?.hours?.includes('Geschlossen') || schedule?.hours?.includes('Closed');
              
              return (
                <div
                  key={index}
                  className={`flex items-center justify-between p-3 rounded-lg transition-luxury ${
                    isToday ? 'bg-secondary/20 border border-secondary/30' : 'hover:bg-secondary/5'
                  }`}
                >
                  <span className={`font-body ${
                    isToday ? 'font-semibold text-secondary' : 'text-white'
                  }`}>
                    {schedule?.day}
                    {isToday && (
                      <span className="ml-2 text-xs bg-secondary/20 text-secondary px-2 py-1 rounded-full">
                        {language === 'de' ? 'Heute' : 'Today'}
                      </span>
                    )}
                  </span>
                  <span className={`font-body font-medium ${
                    isClosed ? 'text-red-400' : 'text-green-400'
                  }`}>
                    {schedule?.hours}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpeningHours;